import React from "react"


import Layout2 from "../components/layout2"
import SEO from "../components/seo"


import InternLinks from "../components/internlinks";
import { FaCheck } from 'react-icons/fa';
import { Breadcrumb } from "../components/globals/breadcrumb";

const IndexPage = () => (
  <Layout2>
    <Breadcrumb category={["recensioner", "recensioner"]} page={["White One", "whiteone"]}/>
     <SEO title="White One" description="Recension av White One" keywords={[`White One`, `Vita tänder hemma`, `Tandblekning`, `Fina tänder`]}/>
     <section className="section-produkter">
       <article>
       <div className="prod-text">
          <h1>Vita tänder med White One</h1>
         </div>
      </article>
      <article class="right">
        <img src="../tandblekning-whiteone.jpg" alt="White One Tandblekning"/>
        <aside>
        <h3 class="erbj-pris">599:-</h3><span class="ord-pris">(799:-)</span>
          <h2>Ultimate - Tandblekningskit</h2>
          <p>Ett prisvärt startkit för tandblekning hemma. </p>
          <a href="https://clk.tradedoubler.com/click?p(300989)a(3146093)g(24632076)url(https://www.whiteone.com/product/ultimate)" target="_blank" rel="noopener noreferrer" class="btn btn-warning btn-width">Beställ här</a><img src="http://impse.tradedoubler.com/imp?type(inv)g(24632076)a(3146093)" height="1px" width="1px" alt=""/>
          <ul>
            <li><FaCheck className="li-icon" /> Gratis expressfrakt över 699 kr</li>
            <li><FaCheck className="li-icon" /> 1-2 dagars leverans</li>
            <li><FaCheck className="li-icon" /> 9/10 på Prisjakt</li>
          </ul>
        </aside>
        <div className="prod-text"><h5>Om produkten</h5>
         <p>Paketet innehåller olika tandblekningsprodukter. Börja med tandblekningspennan i 14 dagar för att sedan övergå till 
           tandkrämen och sprayen för hålla dina tänder vita en längre period.</p>
           <p>Förpackningen innehåller: </p>
            <ul class="ben-list">
              <li>1st Tandblekningspenna</li> 
              <li>1st Blue Light™ - Plasmaljus</li> 
              <li>1st Tandblekningsmunspray</li> 
              <li>1 st Tandblekningstandkräm</li> 
              <li>1 st Tandkarta</li>
            </ul>
          </div>
       </article>
       <article>
        <img src="../tanblekning-whitestrips.jpg" alt="Dentaworks tandblekningspenna"/> 
        <aside>
          <h3 class="erbj-pris">399:-</h3><span class="ord-pris">(599:-)</span>
          <h2>Tandblekningsstrips</h2>
          <p>Enklare tandblekning hemma med strips. Effektiv tandblekning på bara 14 dagar, oavsett om du kör bil eller 
            sitter i soffan på kvällen och ser på tv.</p>
          <a href="https://clk.tradedoubler.com/click?p(300989)a(3146093)g(24632076)url(https://www.whiteone.com/product/white-strips-3d)" target="_blank" rel="noopener noreferrer" class="btn btn-warning btn-width">Beställ här</a><img src="https://impse.tradedoubler.com/imp?type(inv)g(24632076)a(3146093)" height="1px" width="1px" alt=""/>
        <ul>
          <li><FaCheck className="li-icon" /> För ett snabbt, effektivt och säkert resultat</li>
            <li><FaCheck className="li-icon" /> Ingen risk för ilningar</li>
            <li><FaCheck className="li-icon" /> 9/10 på Trustpilot</li>
          </ul>

        </aside>
        <div className="prod-text"><h5>Om produkten</h5>
        <p>Dessa whitening strips är speciellt utvecklade för att du ska kunna bleka tänderna så effektivt som möjligt under 14 dagar.
        White Strips 3D har en formula med den högsta godkända blekningseffekten du kan hitta på marknaden för hemmatandblekning. 
        Den ger dig så snabba resultat att de flesta redan ser resultat efter 2-3 dagars användning.</p></div>
      </article>
      <article>
        <img src="../tandblekningspenna-white.jpg" alt="White One tandblekningspenna"/> 
        <aside>
          <h3>349:-</h3>
          <h2>Tandblekningspenna</h2>
          <p>Tandblekning hemma med tandblekningspenna. Peroxidfri, EU-godkänd tandblekning för 14 dagar!</p>
          <a href="https://clk.tradedoubler.com/click?p(300989)a(3146093)g(24632076)url(https://www.whiteone.com/product/tandblekningspenna)" target="_blank" rel="noopener noreferrer" class="btn btn-warning btn-width">Beställ här</a><img src="https://impse.tradedoubler.com/imp?type(inv)g(24632076)a(3146093)" height="1px" width="1px" alt=""/>
        <ul>
        <li><FaCheck className="li-icon" /> Gratis expressfrakt över 699 kr</li>
            <li><FaCheck className="li-icon" /> 1-2 dagars leverans</li>
            <li><FaCheck className="li-icon" /> 9/10 på Prisjakt</li>
          </ul>

        </aside>
        <div className="prod-text"><h5>Om produkten</h5>
        <p>Tandblekningspennan är vår deras absoluta bästsäljare och är extra effektiv för att snabbt få vitare tänder hemma. 
          Det aktiva ämnet sodiumperborat motverkar åldersfläckar och missfärgningar ifrån exempelvis rödvin, cigaretter och kaffe,
          och ger dig vitare tänder utan att emaljen skadas.</p></div>
      </article>
      <article>
        <div className="prod-text"><h3>Om White one fakta</h3>
        <p>White One har flera enklare produkter. Stripes, tandblekningspenna, tandblekningstandkräm bla. 
            Samtliga produkter genomgår tester och är bevisat effektiva för att säkerställa att de verkligen ger resultat.
            White One®'s främst uppgift är att ta fram enkla produkter, som alla gör otroliga resultat på ditt utseende.</p>
            <p>De har endast Klarna som betalningsalternativ på deras hemsida. </p>
            <p>Man säljer även mycket annat, kosmetika, kosttillskott bla.</p>
            <a href="https://clk.tradedoubler.com/click?p(300989)a(3146093)g(24632076)url(https://www.whiteone.com/product/tandblekningspenna)" target="_blank" rel="noopener noreferrer">Se alla deras produkter här</a><img src="https://impse.tradedoubler.com/imp?type(inv)g(24632076)a(3146093)" height="1px" width="1px" alt=""/>
       </div>
      </article>
       </section>
       {/* <section className="section-cards">
    <main>
    <h2 class="rubrik-tandblekning">Bästa tandblekningen hemma</h2>
       <Card />
       </main>
  </section> */}

      {/* <article>
        <img src="./tandblekningspenna-dentaworks.jpg" alt="Dentaworks tandblekningspenna"/> 
        <aside>
          <h3>399:-</h3>
          <h2>Dentaworks tandblekningspenna</h2>
          <a href="https://track.adtraction.com/t/t?a=25976272&amp;as=1480987224&amp;t=2&amp;tk=1" target="_blank" rel="noopener noreferrer" class="btn btn-warning btn-width">Beställ här</a>
          <ul>
             <li><i class="fa-li fa fa-check"></i> ca 30 behandlingar</li>
             <li><i class="fa-li fa fa-check"></i> Enkel och smidig</li>
             <li><i class="fa-li fa fa-check"></i> Penselborsten kommer åt överallt</li>
          </ul>

        </aside>
        <div className="prod-text"><h3>Dentaworks tandblekningspenna</h3>
        <p>Effektiv och säker tandblekning hemma. Det är en produkt för tandblekning som är helt peroxidfri och EU-godkänd.
            Det aktiva ämnet sodiumperborat motverkar åldersfläckar och missfärgningar ifrån exempelvis rödvin, cigaretter och 
            kaffe, och ger dig vitare tänder utan att emaljen skadas.</p></div>
      </article>
      <article>
        <div className="prod-text"><h3>Om dentaworks</h3>
        <p>Dentaworks produkter är veganska och inte testade på djur. 
         Tandblekning bleker bort missfärgningar och ger dig vitare tänder. På deras site finns det även mycket andra bra produkter för att sköta din tandhygien. Tex, tungskrapa, 
                    tandstensverktyg, munspegel. En smidig lösning med dentaworks är att dom har Klarna som betalningsmetod 
                    på deras site.</p></div>
      </article> */}

  

  <section className="section-cards card-height">
  <main>
      <h2 class="internal-rubrik">Bästa tandblekningen hemma</h2>
    <InternLinks />
    </main>
  </section>
  </Layout2>
)

export default IndexPage

